import platform from 'components/Trackers/platform'

export const ScreenViewedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Feature Lander Screen Viewed',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'mocRegistrationFunnelFeatureLander',
  screen: 'mocRegistrationFunnelFeatureLander',
  screen_name: 'mocRegistrationFunnelFeatureLander',
  section: 'investOnboarding',
}

export const NextButtonTappedEvent = cta_title => {
  return {
    feature: 'MOC Registration Funnel',
    event_description: 'Feature Lander Next Button Tapped',
    platform,
    object: 'Button',
    action: 'Tapped',
    object_name: 'mocRegistrationFunnelFeatureLander',
    screen: 'mocRegistrationFunnelFeatureLander',
    screen_name: 'mocRegistrationFunnelFeatureLander',
    destination: 'investOnboarding',
    cta_title,
    section: 'investOnboarding',
  }
}
